import { render, staticRenderFns } from "./DashboardSupplier.vue?vue&type=template&id=6cd9cde8&"
import script from "./DashboardSupplier.vue?vue&type=script&lang=js&"
export * from "./DashboardSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports